import { dpprApiPost, dpprApiGet } from 'utils/http'
import httpExceptionUtil from 'utils/httpExceptionUtil'

export const postDetails = async (data) => {
  try {
    return await dpprApiPost({ url: '/public/details', data })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const sendVerificationCode = async (data) => {
  try {
    return await dpprApiPost({ url: '/public/sendVerificationCode', data })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const verifyCode = async (data) => {
  try {
    return await dpprApiPost({ url: '/public/verifyCode', data })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchPartialReport = async (integratorShortName, countryCode, propertyId) => {
  try {
    return await dpprApiGet({ url: `/public/partial/${integratorShortName}/${countryCode}/${propertyId}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchReportThreshold = async (integratorId) => {
  try {
    return await dpprApiGet({ url: `/public/reportThreshold/${integratorId}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}
